import { v4 as uuidv4 } from 'uuid';

import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { IKnmApprove248 } from '../../../APIPackage/KnmModule/interfaces/IKnmApprove248';
import { IKnmRemarkSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmRemarkSelectOption';

export const convertKnmApproveRemarksToFormValues = (
  values: IKnmApprove248['remarks'],
  knmRemarksSelectOptions: IKnmRemarkSelectOption[],
): IKnmForm['approveRemarks'] => {
  return values?.map(remarkItem => {
    const remarkSelectOption = knmRemarksSelectOptions.find(item => item.id === remarkItem.remarkId);

    return {
      guid: remarkItem.guid || undefined,
      listId: remarkItem.guid || uuidv4(),
      sectionCode: remarkItem.section,
      remark: remarkSelectOption,
      description: remarkItem.description || undefined,
      changes: remarkItem.changes || undefined,
    };
  });
};
